import type { GetOneResponse } from "@refinedev/core";
import type { QueryObserverResult } from "@tanstack/react-query";
import type { Menu } from "utils/types/menu.type";
import type { Property } from "utils/types/object.type";
import type { UserRole } from "utils/types/user.type";
import { create, type StateCreator } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";

interface GlobalStore {
  propertyId?: string;
  property?: Property;
  propertyQueryData?: QueryObserverResult<GetOneResponse<Property>, unknown>;
  setPropertyId: (id?: string) => void;
  setProperty: (property?: Property) => void;
  setPropertyQueryData: (query: QueryObserverResult<GetOneResponse<Property>, unknown>) => void;
  menus: Menu[];
  setMenus: (menus: Menu[]) => void;
  roles: UserRole[];
  setRoles: (roles: UserRole[]) => void;
}

const initialMenusState = {
  propertyId: "",
  menus: [],
  roles: [],
} satisfies Partial<GlobalStore>;
const globalStoreCreator: StateCreator<GlobalStore> = (set, get) => ({
  ...initialMenusState,
  setPropertyId: (id) => set({ propertyId: id }),
  setProperty: (property) => set({ property }),
  setPropertyQueryData: (query) => set({ propertyQueryData: query }),
  setMenus: (menus) => set({ menus }),
  setRoles: (roles) => set({ roles }),
});
export const useGlobalStore = create<GlobalStore>()(
  devtools(
    persist(globalStoreCreator, {
      name: "global-storage",
      storage: createJSONStorage(() => localStorage),
    })
  )
);
